document.addEventListener('DOMContentLoaded', function() {
  // Funktion zur Initialisierung des Hover-Verhaltens für ein Mega-Menü
  function initializeMegaMenuHover(menuContainer) {
    // Alle summary-Elemente innerhalb eines bestimmten Mega-Menüs finden
    const allSummaries = menuContainer.querySelectorAll('summary');
    
    if (allSummaries.length > 0) {
      // Alle zugehörigen details-Elemente
      const allDetails = Array.from(allSummaries).map(summary => summary.parentElement);
      
      // Event-Listener für alle summary-Elemente hinzufügen
      allSummaries.forEach(function(summary, index) {
        summary.addEventListener('mouseenter', function() {
          // Alle anderen details-Elemente im SELBEN Mega-Menü schließen
          allDetails.forEach(function(details) {
            if (details !== summary.parentElement) {
              details.removeAttribute('open');
            }
          });
          
          // Das aktuelle details-Element öffnen
          summary.parentElement.setAttribute('open', '');
        });
      });
    }
  }
  
  // Alle Mega-Menü-Columns auf der Seite finden und initialisieren
  const megaMenuColumns = document.querySelectorAll('.mega-menu-column');
  megaMenuColumns.forEach(function(menuColumn) {
    initializeMegaMenuHover(menuColumn);
  });
});